import React from 'react'
import {
	MessageCookieOffWrapper,
	MessageCookieOffDescription,
	MessageCookieOffSubDescription,
} from './style'

const MessageCookieOff = () => {
	return (
		<MessageCookieOffWrapper>
			<MessageCookieOffDescription>
				Returnado can't load the returns dialogue because your browser
				is blocking cookies.
			</MessageCookieOffDescription>
			<MessageCookieOffSubDescription>
				Please change browser settings to allow third-party cookies and
				reload this page.
			</MessageCookieOffSubDescription>
		</MessageCookieOffWrapper>
	)
}

export default MessageCookieOff
